type BooleanFlagKey =
  | "initech-customer-portal-web"
  | "move-gig-to-the-past"
  | "allow-boosting-gig-manually"
  | "message-support-button-visable"
  | "maintenance-mode"
  | "temp-show-gig-autoselect-toggle"
  | "enable-auto-match-setting-display"
  | "qwick-homepage"
  | "require-industry-certifications"
  | "manager-admin-clock-in";

type ValueFlags = {
  /**
   * 0: Engage Off
   * 1: Engage Phase 1 - MVP
   * 2: Engage Phase 2 - Assign a Gig
   * 3: Engage Phase 3 - Events Phase 1
   * 4: Engage Phase 4 - Events Phase 2
   * 5: Engage Phase 5 - Events Phase 3
   * 6: Engage Phase 6 - Tipping
   * 7: Engage Phase 7 - Post to Marketplace
   */
  "engage-phased": 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
  /**
   * 0: Jobs Off
   * 1: Jobs Phase 1
   */
  "jobs-phased": 0 | 1;
  /**
   * 0: Disabled
   * 1: Review table
   * 2: Batch ratings & payments
   */
  "temp-bulk-review": 0 | 1 | 2;
};
type ValueFlagKey = keyof ValueFlags;

export type FeatureFlagKey = BooleanFlagKey | ValueFlagKey;
export type FeatureFlagValue = Record<BooleanFlagKey, boolean> & ValueFlags;

export const defaultFlags: FeatureFlagValue = {
  "initech-customer-portal-web": false,
  "move-gig-to-the-past": false,
  "allow-boosting-gig-manually": false,
  "message-support-button-visable": false,
  "maintenance-mode": false,
  "temp-show-gig-autoselect-toggle": false,
  "engage-phased": 0,
  "jobs-phased": 0,
  "temp-bulk-review": 0,
  "enable-auto-match-setting-display": true,
  "qwick-homepage": false,
  "require-industry-certifications": true,
  "manager-admin-clock-in": false,
};
